/**
 * Shared detection for whether the UI is running inside the installed/native app
 * rather than a regular browser tab.
 *
 * The Capacitor native shell appends "VesselindexApp" to the user agent
 * (see mobile-app/capacitor.config.json) and installed PWAs report a
 * standalone display mode.
 */

/**
 * True only for the Capacitor native app (iOS/Android wrapper).
 * @returns {boolean}
 */
export const isCapacitorApp = () =>
  typeof navigator !== 'undefined' && navigator.userAgent.includes('VesselindexApp')

/**
 * True for any "app-like" context (as opposed to a regular browser tab):
 * the native Capacitor app or an installed PWA (standalone display mode /
 * iOS home-screen webapp / Android TWA).
 * @returns {boolean}
 */
export const isAppMode = () =>
  (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
  window.navigator.standalone === true ||
  (document.referrer && document.referrer.includes('android-app://')) ||
  isCapacitorApp()
